import { Link, useLocation } from 'react-router-dom'
import { Users, Envelope, ChartBar } from '@phosphor-icons/react'

const ADMIN_LINKS = [
  { href: '/admin/users', label: 'Users', icon: Users },
  { href: '/admin/invitations', label: 'Invitations', icon: Envelope },
  { href: '/admin/progress', label: 'Progress', icon: ChartBar },
]

export default function AdminNav() {
  const location = useLocation()
  const pathname = location.pathname

  return (
    <nav className="admin-nav" aria-label="Admin">
      <ul>
        {ADMIN_LINKS.map((l) => {
          const Icon = l.icon
          const isActive = pathname === l.href
          return (
            <li key={l.href}>
              <Link
                to={l.href}
                data-active={isActive ? 'true' : undefined}
                className={isActive ? 'admin-nav__link--active' : ''}
              >
                <Icon weight={isActive ? 'bold' : 'regular'} size={18} aria-hidden="true" />
                <span>{l.label}</span>
              </Link>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}
